var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Form",
        {
          ref: "formValidate",
          attrs: { model: _vm.formItem, "label-width": 80 }
        },
        [
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "选择门店", prop: "store_id" } },
                        [
                          _c("dropCheckBox", {
                            attrs: {
                              type: "delayStoreList",
                              checkAllGroup: _vm.formItem.store_id,
                              checkboxData: _vm.storeList,
                              placeholder: "请选择",
                              checkedValue: _vm.signStoreCheckedShowValue
                            },
                            on: { delayStoreList_even: _vm.signStoreList }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "录入时间", prop: "enter_time" } },
                        [
                          _c("DatePicker", {
                            staticStyle: { display: "block" },
                            attrs: {
                              type: "daterange",
                              placeholder: "请选择",
                              placement: "bottom-end"
                            },
                            on: { "on-change": _vm.changeEnterTime },
                            model: {
                              value: _vm.formItem.enter_time,
                              callback: function($$v) {
                                _vm.$set(_vm.formItem, "enter_time", $$v)
                              },
                              expression: "formItem.enter_time"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "渠道", prop: "enter_department_id" }
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择部门" },
                              on: { "on-change": _vm.changeChannel },
                              model: {
                                value: _vm.formItem.enter_department_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem,
                                    "enter_department_id",
                                    $$v
                                  )
                                },
                                expression: "formItem.enter_department_id"
                              }
                            },
                            _vm._l(_vm.departmentChannel, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "3" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { "label-width": 0, prop: "channel_id" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "请选择渠道"
                              },
                              model: {
                                value: _vm.formItem.channel_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "channel_id", $$v)
                                },
                                expression: "formItem.channel_id"
                              }
                            },
                            _vm._l(_vm.channel, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "跟进人",
                            prop: "follow_department_id"
                          }
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择部门" },
                              on: { "on-change": _vm.changeFollowr },
                              model: {
                                value: _vm.formItem.follow_department_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formItem,
                                    "follow_department_id",
                                    $$v
                                  )
                                },
                                expression: "formItem.follow_department_id"
                              }
                            },
                            _vm._l(_vm.departmentFollow, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "3" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { "label-width": 0, prop: "follow_user_id" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择跟进人" },
                              model: {
                                value: _vm.formItem.follow_user_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "follow_user_id", $$v)
                                },
                                expression: "formItem.follow_user_id"
                              }
                            },
                            _vm._l(_vm.followr, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.user_name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "mb-10",
                      attrs: { label: "分配时间", prop: "allot_time" }
                    },
                    [
                      _c("DatePicker", {
                        staticStyle: { display: "block" },
                        attrs: { type: "daterange", placeholder: "请选择" },
                        model: {
                          value: _vm.formItem.allot_time,
                          callback: function($$v) {
                            _vm.$set(_vm.formItem, "allot_time", $$v)
                          },
                          expression: "formItem.allot_time"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "4" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "关键字", prop: "keywords" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "姓名/手机" },
                        model: {
                          value: _vm.formItem.keywords,
                          callback: function($$v) {
                            _vm.$set(_vm.formItem, "keywords", $$v)
                          },
                          expression: "formItem.keywords"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.search }
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    { attrs: { type: "primary" }, on: { click: _vm.reset } },
                    [_vm._v("清空筛选")]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.excelCustomer }
                    },
                    [_vm._v("导出客户Excel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c("Table", {
            ref: "table",
            attrs: {
              stripe: "",
              loading: _vm.loading,
              border: "",
              columns: _vm.t_head,
              data: _vm.t_data,
              height: _vm.tableHeight
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                display: "flex",
                "justify-content": "flex-end"
              }
            },
            [
              _c("Page", {
                attrs: {
                  total: _vm.pagination.total,
                  "page-size": _vm.pagination.per_page,
                  "show-total": "",
                  "show-elevator": "",
                  "show-sizer": "",
                  transfer: true,
                  "page-size-opts": _vm.pageSizeOpts
                },
                on: {
                  "on-page-size-change": _vm.changeLimit,
                  "on-change": _vm.changePages
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("customerExcel", {
        attrs: {
          excelTitle: _vm.excelTitle,
          excelSteps: _vm.excelSteps,
          downloadLink: _vm.downloadLink,
          customerExcelShow: _vm.customerExcelShow
        },
        on: { customerExcelEven: _vm.customerExcelEven }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-afdd194e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afdd194e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Crm/ReturnManagement/delayFollowUpRecord.vue
// module id = null
// module chunks = 